import { createFileRoute } from "@tanstack/react-router";
import { PortalLandingPage } from "@/components/portal/PortalLandingPage";

export const Route = createFileRoute("/portal/")({
  component: PortalHomePage,
});

function PortalHomePage() {
  return <PortalLandingPage />;
}
